import React from 'react';
import { Link } from 'react-router-dom';
import styled from 'styled-components';
import OrderStatusBadge from './OrderStatusBadge';
import PaymentCardDisplay from './PaymentCardDisplay';

const Card = styled(Link)`
  display: block;
  background: #fff;
  border-radius: 8px;
  padding: 20px;
  margin-bottom: 16px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.1);
  text-decoration: none;
  color: inherit;
  transition: box-shadow 0.2s ease, transform 0.2s ease;

  &:hover {
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
    transform: translateY(-2px);
    text-decoration: none;
    color: inherit;
  }
`;

const TopRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 12px;
`;

const OrderInfo = styled.div`
  flex: 1;
`;

const OrderId = styled.div`
  font-size: 16px;
  font-weight: 600;
  color: #333;
  margin-bottom: 4px;
`;

const OrderDate = styled.div`
  font-size: 14px;
  color: #666;
`;

const GrandTotal = styled.div`
  font-size: 18px;
  font-weight: 600;
  color: #333;
`;

const BottomRow = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const LeftInfo = styled.div`
  display: flex;
  flex-direction: column;
  gap: 4px;
`;

const Students = styled.div`
  font-size: 14px;
  color: #666;
`;

const ItemsCount = styled.div`
  font-size: 13px;
  color: #999;
`;

const StatusWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`;

const RefundAmount = styled.div`
  font-size: 13px;
  color: #ea580c;
`;

const formatPrice = (cents) => {
  if (cents === null || cents === undefined) return '$0.00';
  return '$' + (cents / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
};

const OrderCard = ({ order }) => {
  const {
    order_id,
    code,
    formatted_date,
    grand_total,
    is_cancelled,
    total_refunded,
    payment_card_brand,
    payment_card_last4,
    students,
    items_count,
  } = order;

  return (
    <Card to={`/my-orders/${order_id}`}>
      <TopRow>
        <OrderInfo>
          <OrderId>{code}</OrderId>
          <OrderDate>{formatted_date}</OrderDate>
        </OrderInfo>
        <GrandTotal>{formatPrice(grand_total)}</GrandTotal>
      </TopRow>

      <BottomRow>
        <LeftInfo>
          {students && students.length > 0 && (
            <Students>
              {students.join(', ')} - {items_count} item
              {items_count !== 1 ? 's' : ''}
            </Students>
          )}
          <PaymentCardDisplay
            cardBrand={payment_card_brand}
            cardLast4={payment_card_last4}
          />
        </LeftInfo>

        <StatusWrapper>
          {total_refunded > 0 && !is_cancelled && (
            <RefundAmount>-{formatPrice(total_refunded)}</RefundAmount>
          )}
          <OrderStatusBadge
            isCancelled={is_cancelled}
            totalRefunded={total_refunded}
            grandTotal={grand_total}
          />
        </StatusWrapper>
      </BottomRow>
    </Card>
  );
};

export default OrderCard;
